import { motion } from "framer-motion";
import { ArrowUpRight, MoonStar } from "lucide-react";
import { SITE } from "@/lib/api";

export const SoldOutNotice = ({ dateLong, title }) => (
  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
    data-testid="sold-out-notice" className="glass-strong rounded-[1.5rem] p-10 flex flex-col items-center text-center gap-4">
    <div className="glass rounded-full w-14 h-14 flex items-center justify-center"><MoonStar className="w-6 h-6 text-white" strokeWidth={1.4} /></div>
    <p className="text-xs tracking-[0.3em] uppercase text-white/60 font-body font-medium">{dateLong}</p>
    <h2 className="font-heading italic text-white text-3xl tracking-[-1px]">{title}</h2>
    <p className="text-sm text-white/80 font-body font-light max-w-xs">
      Tutti i posti per questa serata sono stati assegnati. Grazie per l'entusiasmo — non vediamo l'ora di rivederti.
    </p>
    <p className="text-xs text-white/50 font-body font-light max-w-xs">
      Presto nuovi eventi Eclipsia: seguici su Instagram per essere il primo a saperlo.
    </p>
    <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="sold-out-instagram-button"
      className="bg-white text-black rounded-full px-6 py-3.5 text-sm font-medium font-body flex items-center gap-2 mt-2 hover:opacity-90 transition-opacity">
      Seguici su Instagram <ArrowUpRight className="w-4 h-4" />
    </a>
  </motion.div>
);
